import React from 'react'

export const Curriculum = () => {
  return (
    <div className='page'>
      <h1 className='heading'>Curriculum</h1>
      <h2>Perfil</h2>
      <ul>
        <li>
        Desarrollador Junior de React autodidacta con una sólida base en lenguajes de programación como JavaScript, HTML y CSS. Ha completado numerosos cursos en línea y proyectos personales para desarrollar sus habilidades , con una pasión por crear aplicaciones web de alta calidad . Dispuesto a obtener resultados positivos , con experiencia confirmada en el área de logística , almacenamiento y ventas, especialista en la gestión eficaz de todas las operaciones .Capaz de Contribuir con miembros de equipo para cumplir metas pautadas de forma presencial y remota. Interesado en colaborar con organizaciones para cumplir sus objetivos e implementar procesos de desarrollo que conlleven a tomar las mejores decisiones para la empresa.
        </li>
      </ul>
      <h2>Competencias Tecnicas</h2>
      <ul>
        <li>ReactJs</li>
        <li>JavaScript</li>
        <li>HTML5</li>
        <li>CSS</li>
        <li>Github</li>
      </ul>
      <h2>Experiencia</h2>
      <ul>
        <li>Gerente De Ventas 2019-2023</li>
        <li>Jefe de Almacen y Logistica 2013-1019</li>
      </ul>
      <h2>Proyectos Personales</h2>
      <ul>
        <li><a href='https://rockedmfestjg.netlify.app' target='_blank' rel='noopener noreferrer'>Rock EDM Fest</a></li>
        <li><a href='https://blogdecafejgomez.netlify.app' target='_blank' rel='noopener noreferrer'>Blog de Café</a></li>
        <li><a href='https://frontendstorejg1.netlify.app' target='_blank' rel='noopener noreferrer'>Front-End Store</a></li>
      </ul>
      <h2>Certificados y Cursos</h2>
      <ul>
        <li><a href='https://freecodecamp.org/certification/johanmg23/javascript-algorithms-and-data-structures' target='_blank' rel='noopener noreferrer'>JavaScript Algorithms and Data Structures</a></li>
        <li><a href='https://www.efset.org/cert/jh5GHZ' target='_blank' rel='noopener noreferrer'>EF SET English Certificate</a></li>
      </ul>
    </div>
  )
}
